import http from '@/utils/request'
import type { AuthUser } from '@/utils/auth'

export interface LoginRequest {
  code: string
  password: string
}

export interface LoginResponse {
  user: AuthUser
  accessToken: string
  refreshToken: string
}

export interface RefreshTokenResponse {
  accessToken: string
  refreshToken: string
}

/**
 * 登录接口
 */
export async function login(data: LoginRequest): Promise<LoginResponse> {
  const response = await http.post<LoginResponse>('/auth/login', data, {
    skipAuth: true,
  })
  return response.data as LoginResponse
}

/**
 * 刷新令牌
 */
export async function refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
  const response = await http.post<RefreshTokenResponse>(
    '/auth/refresh',
    { refreshToken },
    { skipAuth: true }
  )
  return response.data as RefreshTokenResponse
}
